import { useSectionContext, SectionId } from "../../hooks/useSectionContext";
import SidebarItem from "./SidebarItem";

export const sidebarItems = (): {
  id: SectionId;
  title: string;
}[] => [
  { id: "basic", title: "Basic Info & Pricing" },
  { id: "access", title: "Plan Access" },
  { id: "sales", title: "Plan Purchase Page" },
];

export default function PlanModalSidebar() {
  const { activeSection, scrollToSection } = useSectionContext();

  return (
    <div className="max-sm:tw-hidden tw-w-52 tw-py-4 tw-px-3 tw-flex tw-flex-col tw-gap-2">
      {sidebarItems().map((item) => (
        <SidebarItem 
          key={item.id}
          title={item.title}
          isActive={activeSection === item.id}
          onClick={() => scrollToSection(item.id, "smooth")}
          sectionId={item.id}
        />
      ))}
    </div>
  );
} 